// extracted by mini-css-extract-plugin
module.exports = {"headerPlaceholder":"HeaderPlaceholder_headerPlaceholder__MtRMu","hasLanguageRow":"HeaderPlaceholder_hasLanguageRow__Zevh7"};